import React from "react";

interface DefaultProfileProps {
  size?: number;
  className?: string;
}

export const DefaultProfile: React.FC<DefaultProfileProps> = ({
  size = 64,
  className = "",
}) => {
  return (
    <div
      className={`bg-background-5 flex items-center justify-center rounded-full ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size * 0.6} // Make icon 60% of container size
        height={size * 0.6}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Head circle */}
        <circle
          cx="12"
          cy="8"
          r="4"
          fill="currentColor"
          className="text-foreground-5"
        />
        {/* Body/shoulders path */}
        <path
          d="M20 20c0-4.4-3.6-8-8-8s-8 3.6-8 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          className="text-foreground-5"
        />
      </svg>
    </div>
  );
};
